import {
  getG11nAndTranslationsFromServer,
  type TCustomGetServerSideProps,
} from '@crehana/next';

import { USER_DASHBOARD_PAGE_KEY } from '../constants';
import locales from '../i18n';
import { IAppProps } from '../types';

const getServerSideProps: TCustomGetServerSideProps<IAppProps> = async ({
  req,
}) => {
  const g11nData = await getG11nAndTranslationsFromServer({
    headers: req.headers,
    pageKey: USER_DASHBOARD_PAGE_KEY,
    defaultTranslations: locales,
  });

  return {
    props: {
      ...g11nData,
      pageUrl: req.url,
      // NOTE: In the user dashboard page we don't have the organization slug but we need it to be sent to the app.
      organizationSlug: '',
    },
  };
};

export default getServerSideProps;
